module.exports = __webpack_public_path__ + "img/door.a3bc9b75.svg";